// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__12iD8","tab":"ProcedureTabs_tab__2zDKK"};